import { useInfiniteQuery } from '@tanstack/react-query'
import axios from 'axios'
import z from 'zod'

async function getChatHistory({
  page,
  page_size,
}: {
  page: number
  page_size: number
}) {
  const response = await axios.get('/api/clair/sessions-auth', {
    params: {
      page: page,
      page_size: page_size,
    },
  })
  return {
    data: z.array(SessionSchema).parse(response.data.data),
    totalCount: response.data.total_count,
  }
}

export function useChatHistoryInfinite(opened: boolean) {
  return useInfiniteQuery({
    queryKey: ['chatHistoryInfinite'],
    queryFn: ({ pageParam }) =>
      getChatHistory({ page: pageParam, page_size: 10 }),
    initialPageParam: 1,
    enabled: opened,
    getNextPageParam: (lastPage, allPages) => {
      const loadedCount = allPages.flatMap((page) => page.data).length
      const totalCount = lastPage.totalCount

      if (loadedCount < totalCount) {
        return allPages.length + 1
      } else {
        return undefined
      }
    },
  })
}

export const SessionSchema = z.object({
  id: z.number(),
  session_id: z.string(),
  user_id: z.number(),
  platform_id: z.number(),
  title: z.string(),
  status: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
})

export type Session = z.infer<typeof SessionSchema>
